import { render, staticRenderFns } from "./TextCarouselSection.vue?vue&type=template&id=d1aa090c&scoped=true"
import script from "./TextCarouselSection.vue?vue&type=script&lang=ts"
export * from "./TextCarouselSection.vue?vue&type=script&lang=ts"
import style0 from "./TextCarouselSection.vue?vue&type=style&index=0&id=d1aa090c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1aa090c",
  null
  
)

export default component.exports